import React from 'react'

function Error() {
  return (
    <div className='container wrappingDiv'>
      <h1> error occured</h1>
    </div>
  )
}

export default Error
